// extracted by mini-css-extract-plugin
export default {"sideMenuFooter":"styles_side-menu-footer__mt5g1"};